export const curadoria = {
  lista: {
    title: 'Trilhas · Curadoria',
    description: 'Componha e gerencie as trilhas de aprendizado.',
    novaTrilha: 'Nova trilha',
    colTitulo: 'Título',
    colStatus: 'Status',
    colAtualizado: 'Atualizado em',
    abrir: 'Abrir editor',
    empty: 'Nenhuma trilha criada ainda. Monte a primeira jornada da sua equipe.',
  },
  criar: {
    title: 'Nova trilha',
    description: 'Defina os metadados; a trilha nasce como rascunho, sem cursos.',
    title_label: 'Título',
    objetivo_label: 'Objetivo',
    descricao_label: 'Descrição',
    emiteCert_label: 'Emite certificado',
    criar: 'Criar trilha',
    sucesso: 'Trilha criada.',
  },
  editor: {
    voltar: 'Voltar para as trilhas',
    title: 'Editor de trilha',
    metadados: 'Metadados',
    salvar: 'Salvar metadados',
    salvo: 'Metadados salvos.',
    emiteCertCongelado:
      'O certificado foi congelado na primeira publicação e não pode mais ser alterado.',
    publicar: 'Publicar',
    arquivar: 'Arquivar',
    republicar: 'Republicar',
    publicado: 'Trilha publicada.',
    arquivado: 'Trilha arquivada.',
    atribuir: 'Atribuir',
    cursos: 'Cursos da trilha',
    cursosVazio: 'Esta trilha ainda não tem cursos. Adicione o primeiro.',
    addCurso: '+ Curso',
    moverCima: 'Mover para cima',
    moverBaixo: 'Mover para baixo',
    removerCurso: 'Remover curso',
    removerCursoConfirm: 'Remover este curso da trilha?',
    removerCursoDesc: 'O curso continua existindo; apenas sai da composição desta trilha.',
    cursoRemovido: 'Curso removido da trilha.',
    ordemSalva: 'Ordem atualizada.',
  },
  prereq: {
    title: 'Pré-requisitos (Trilha → Trilha)',
    description:
      'Declare uma trilha que o aluno deveria concluir antes desta (aviso, não bloqueio).',
    selecione: 'Selecione uma trilha',
    placeholder: 'Escolha a trilha pré-requisito',
    declarar: 'Declarar pré-requisito',
    sucesso: 'Pré-requisito declarado.',
    erroDuplicado: 'Este pré-requisito já existe.',
    erroAuto: 'Uma trilha não pode ser pré-requisito de si mesma.',
  },
  seletor: {
    title: 'Adicionar curso',
    description: 'Apenas cursos publicados podem compor a trilha.',
    empty: 'Nenhum curso publicado disponível.',
    adicionar: 'Adicionar',
    jaNaTrilha: 'Já na trilha',
    adicionado: 'Curso adicionado à trilha.',
    erroDuplicado: 'Este curso já está na trilha.',
    erroArquivado: 'Curso arquivado não entra em novas trilhas.',
  },
  atribuir: {
    title: 'Atribuir a alunos',
    descTrilha: 'Atribua esta trilha a vários alunos com um prazo comum.',
    descCurso: 'Atribua este curso a vários alunos com um prazo comum.',
    alunos: 'Alunos',
    buscarPlaceholder: 'Buscar por nome ou e-mail...',
    selecionar: 'Selecionar alunos',
    nenhumResultado: 'Nenhum usuário encontrado.',
    digiteParaBuscar: 'Digite para buscar usuários.',
    prazo: 'Prazo',
    prazoHint: 'Data no passado é aceita: a matrícula nasce já atrasada.',
    submeter: 'Atribuir',
    submeterN: 'Atribuir a {{count}}',
    resultadoTitle: 'Resultado da atribuição',
    resumo: '{{criadas}} criadas · {{atualizadas}} atualizadas · {{falhas}} falhas',
    colAluno: 'Aluno',
    colDesfecho: 'Desfecho',
    colMotivo: 'Motivo / aviso',
    outcomeCriada: 'Criada',
    outcomeAtualizada: 'Atualizada',
    outcomeFalhou: 'Falhou',
    avisoPrereq: 'Ainda não concluiu: {{titulos}}',
    novaAtribuicao: 'Nova atribuição',
  },
} as const;
